import { useEffect } from 'react';
import { showBetslip } from 'right-sidebar';
import { useLocation } from 'react-router-dom';

export default () => {
  const location = useLocation();

  useEffect(() => {
    if (/show_betslip=(1|true)/.test(location.search)) {
      showBetslip();
    }
  }, [location.search]);
};
